<!-- 日运输管理 -->
<template>
  <div>
    <matrix-statistics span="8" :list="infoCardData(pvCardData)"></matrix-statistics>
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @search-change="(params, done)=>{searchChange(params, done);getCardData(params)}" @search-reset="searchReset" @refresh-change="refreshChange" :beforeOpen="beforeOpen" @current-change="currentChange" @size-change="sizeChange"
      @on-load="(page)=>{onLoad(page);getCardData()}" @selection-change="selectionChange">
      <template slot-scope="{ row }" slot="station">
        <p>发站:{{ row.beginStation }}</p>
        <p>到站:{{ row.endStation }}</p>
      </template>
      <template slot-scope="{row}" slot="planState">
        <matrix-tag v-if="row.planState == 0" color="#854D0E" text="未开始"></matrix-tag>
        <matrix-tag v-if="row.planState == 1" color="#166534" text="已进行"></matrix-tag>
        <matrix-tag v-if="row.planState == 2" color="#32b939" text="已完成"></matrix-tag>
      </template>
      <template #menu="{ size, row }">
        <el-button type="text" :size="size" @click="viewTask(row)">查看任务</el-button>
      </template>
    </avue-crud>
    <showList ref="showList" :chooseOne="chooseOne"></showList>
    <select-contract ref="selectContract" @replace="replace" />
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail, getDaytransportplan } from "./api";
import { searchTimeConfig, rulesInput } from "@/basic-common/util/common";
import matrixStatistics from '@/components/matrix/matrix-statistics'
import matrixTag from '@/components/matrix/matrix-tag';
import showList from './showList.vue'
import SelectContract from "@/views/railway-management/transportplan/components/select-contract.vue";
import { getAllWeekBeforeNowFn } from "@/util/date.js";
import { removePercent } from '@/util/util'

export default {
  components: { matrixStatistics, matrixTag, showList, SelectContract },
  mixins: [crudMixins],
  data () {
    return {
      chooseOne: {},
      apiConfig: { getList, add, update, remove, getDetail },
      option: {
        ...this.$store.state.publicOption,
        addBtn:false,
        editBtn:false,
        delBtn:false,
        column: [
          {
            label: '计划号',
            prop: 'planNo',
            overHidden: true, // 表格超出隐藏
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
          },
          {
            label: '计划名称',
            prop: 'planName',
            search: true, // 查询是否显示
            overHidden: true, // 表格超出隐藏
            width: 150,
            // type: 'select',
            // remote: true,
            allowCreate: true,
            // dicUrl: '/api/produce/produce-schedule/select/distinct/pycode?planName={{key}}',
            props: {
              label: 'planName',
              value: 'planName'
            },
            maxlength: 30,
            rules: rulesInput(1),
          },
          {
            label: '合同名称',
            prop: 'contractName',
            search: true, // 查询是否显示
            overHidden: true, // 表格超出隐藏
            width: 150,
            props: {
              label: 'contractName',
              value: 'id'
            },
            rules: rulesInput(2),
            click: () => {
              const { dialogForm } = this.$refs.crud.$refs
              if (dialogForm.boxVisible) {
                this.$refs.selectContract.open('1')
              }
            },
          },
          {
            label: '货主',
            prop: 'custNo',
            overHidden: true, // 表格超出隐藏
            width: 150,
            search: true, // 查询是否显示
            type: 'select',
            remote: true,
            dicUrl: '/api/produce/blade-dept/select/distinct/select',
            props: {
              label: 'deptName',
              value: 'id'
            },
            rules: rulesInput(2),
          },

          {
            label: '煤种',
            prop: 'cargoName',
            search: false, // 查询是否显示
            overHidden: true, // 表格超出隐藏
            width: 150,
            type: 'select',
            remote: true,
            disabled: true,
            dicUrl: '/api/produce/vardict/select/distinct/pycode?varName={{key}}',
            props: {
              label: 'cargoName',
              value: 'id'
            },
          },
          {
            label: '业务类型',
            prop: 'businessType',
            dataType: 'string',
            type: 'select',
            value: '1',
            dicData: this.$store.getters.commonDict['businessType'],
            // hide: true,
            display: false,
            search: true,
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '计划量(吨)',
            prop: 'planTotalWeight',
            type: 'number',
            precision: 2,
            min: 0.01,
            max: 99999,
            overHidden: true, // 表格超出隐藏
            minWidth: 150,
            maxlength: 30,
            rules: rulesInput(1),
          },
          {
            label: '执行量(吨)',
            prop: 'planExecuteWeight',
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
          },
          {
            label: '车次',
            prop: 'trainNumber',
            overHidden: true, // 表格超出隐藏
            width: 150,
            rules: rulesInput(1),
            maxlength: 30,
          },
          {
            label: '发站',
            prop: 'beginStation',
            hide: true,
            type: 'select',
            filterable: true,
            dicUrl: '/api/produce/station/select/distinct/page',
            props: {
              label: 'stationName',
              value: 'stationCode'
            },
            rules: rulesInput(2),
          },
          {
            label: '到站',
            prop: 'endStation',
            hide: true,
            type: 'select',
            filterable: true,
            dicUrl: '/api/produce/station/select/distinct/page',
            props: {
              label: 'stationName',
              value: 'stationCode'
            },
            rules: rulesInput(2),
          },
          {
            label: '装货时间',
            prop: 'intervalStartTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true, // 表格超出隐藏
            width: 180,
          },
          {
            label: '状态',
            prop: 'planState',
            display: false,
            slot: true,
            overHidden: false,
            minWidth: 100,
            align: 'center',
            className: 'cell-plan-state',
          },
          {
            label: '计划开始时间',
            prop: 'intervalStartTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            value: getAllWeekBeforeNowFn('today') + ' 00:00:00',
            hide: true,
            showColumn: false,
            display: false
          },
          {
            label: '计划结束时间',
            prop: 'intervalEndTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            value: getAllWeekBeforeNowFn('today') + ' 23:59:59',
            hide: true,
            showColumn: false,
            display: false
          },
          {
            label: '合同开始时间',
            prop: 'contractStartTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            hide: true,
            disabled: true,
            showColumn: false,
          },
          {
            label: '合同结束时间',
            prop: 'contractEndTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 120,
            hide: true,
            disabled: true,
            showColumn: false,
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
          },
        ]
      },
      /** 仅日计划；业务类型仍可由搜索区 businessType 筛选 */
      defaultParams: { planType: 2 },
      pvCardData:{}
    }
  },
  computed: {
    infoCardData () {
      return function (pvCardData) {
        return [{
          label: '当月计划入库总量',
          value: pvCardData['planTotalWeight'],
          unit: ' 吨',
        }, {
          label: '当前计划执行量',
          value: pvCardData['planExecuteWeight'],
          unit: ' 吨',
        }, {
          label: '计划完成率',
          value: pvCardData['planProgress'],
          unit: ' %',
        }] // 卡片数据
      }
    }
  },
  methods: {
    viewTask (row) {
      this.chooseOne = row
      this.$refs['showList'].visible = true
    },
    replace (row) {
      const replaceKey = ['id', 'custNo', 'contractEndTime', 'contractStartTime', 'cargoName', 'cargoNo', 'contractName', 'contractNo']
      replaceKey.forEach(item => {
        if (item != 'id') {
          this.$set(this.form, item, row[item])
        } else {
          this.$set(this.form, 'contractExtId', row['id'])
        }
      });
    },
    getCardData () {
      getDaytransportplan({
        ...this.queryData
      }).then(({ data }) => {
        this.pvCardData = data.data
      })
    }
  }
}
</script>
<style scoped lang="scss">
p {
  margin: 0;
}

/* 状态列自定义标签：避免单元格 overflow 裁切 */
::v-deep td.cell-plan-state .cell {
  overflow: visible;
}
</style>
